import React from 'react';
import i18next from 'i18next';
import { string, func, arrayOf, shape, number, bool } from 'prop-types';

import withSpinner from '~components/Spinner';
import ErrorImage from '~components/ErrorContainer';
import { ERROR_IMAGES } from '~components/ErrorContainer/constants';
import Tabs from '~components/Tabs';
import storePropTypes from '~constants/propTypes';
import { googleAddressPropTypes } from '~propTypes/address';

import Delivery from './components/Delivery';
import PickUp from './components/PickUp';
import { TABS_DATA } from './constants';
import styles from './styles.module.scss';

function DeliveryOrPickUp({
  selectedAddress,
  delivery,
  deliveryError,
  stores,
  storesError,
  selectedStore,
  onStoreSelect,
  onConfirm,
  onlyPickup = false,
  onAddressSelect,
  allStores
}) {
  const pickupStores = stores?.length;
  const deliveryStores = Object.keys(delivery || {});
  const onlyDeliveryTabsData = TABS_DATA.filter((tab) => TABS_DATA.indexOf(tab) === 0);

  return (
    <div className={`column full-width ${styles.container}`}>
      {!pickupStores && !deliveryStores ? (
        <ErrorImage
          className="item-1"
          img={ERROR_IMAGES.NO_PICKUP}
          title={storesError ? i18next.t('DeliveryOrPickUp:noData') : i18next.t('DeliveryOrPickUp:pickStore')}
          message={
            storesError
              ? i18next.t('DeliveryOrPickUp:noDataMessage')
              : i18next.t('DeliveryOrPickUp:pickStoreMessage')
          }
        />
      ) : onlyPickup ? (
        allStores?.length && (
          <PickUp
            className={styles.contentBody}
            selectedAddress={selectedAddress}
            stores={allStores}
            error={storesError}
            selectedStore={selectedStore}
            onStoreSelect={onStoreSelect}
            onConfirm={onConfirm}
            onAddressSelect={onAddressSelect}
          />
        )
      ) : (
        <Tabs
          tabData={pickupStores ? TABS_DATA : onlyDeliveryTabsData}
          tabBarClassName={`m-bottom-3 ${styles.tabsBar}`}
          lineSeparator
          notFullWidth>
          <Delivery
            className={styles.contentBody}
            error={deliveryError}
            selectedAddress={selectedAddress}
            deliveryInfo={delivery}
            onConfirm={onConfirm}
          />
          {pickupStores && (
            <PickUp
              className={styles.contentBody}
              selectedAddress={selectedAddress}
              stores={stores}
              error={storesError}
              selectedStore={selectedStore}
              onStoreSelect={onStoreSelect}
              onConfirm={onConfirm}
            />
          )}
        </Tabs>
      )}
    </div>
  );
}

DeliveryOrPickUp.propTypes = {
  onAddressSelect: func.isRequired,
  onConfirm: func.isRequired,
  onStoreSelect: func.isRequired,
  allStores: arrayOf(storePropTypes),
  delivery: shape({
    name: string,
    deliveryWaitTime: number,
    menuId: number
  }),
  deliveryError: string,
  onlyPickup: bool,
  selectedAddress: googleAddressPropTypes,
  selectedStore: storePropTypes,
  stores: arrayOf(storePropTypes),
  storesError: string
};

export default withSpinner({
  WrappedComponent: DeliveryOrPickUp,
  delay: 700,
  simple: true
});
